import Vue from 'vue'
import { login } from '@/api/login'
import {
    ACCESS_TOKEN,
    USER_NAME,
    USER_ID,
    NAME,
    USER_COMPANY_NAME,
    USER_ROLES,
    AUDIT_STATUS,
    APPLY_INFO,
    MENU_ACTIVE,
    IS_MONITORING
} from '@/vue/store/mutation-type'

const expire = 7 * 24 * 60 * 60 * 1000
/* 全局变量 */
const user = {
    state: {
        token: '',
        name: '',
        roles: [],
        userId: '',
        companyName: '',
        userName: '',
        applyInfo: {},
        auditStatus: '', //当前进件单状态
        isMonitoring: true, //监控标识，右上角不显示胶囊菜单
        menuActive: 0 //标签栏激活序号
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_USER_NAME: (state, name) => {
            state.userName = name
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_USER_ID: (state, userId) => {
            state.userId = userId
        },
        SET_COMPANY_NAME: (state, companyName) => {
            state.companyName = companyName
        },
        SET_AUDIT_STATUS: (state, auditStatus) => {
            state.auditStatus = auditStatus
        },
        SET_APPLY_INFO: (state, applyInfo) => {
            state.applyInfo = applyInfo
        },
        SET_ACTIVE: (state, active) => {
            state.menuActive = active
            Vue.ls.set(MENU_ACTIVE, active, expire)
        },
        SET_ISMONITORING: (state, boolean) => {
            state.isMonitoring = boolean
        }
    },

    actions: {
        // 登录
        Login({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo).then(response => {
                    if (response.statusCode == 'success') {
                        commit('SET_TOKEN', response.result.token)
                        commit('SET_NAME', response.result.userInfo.realName)
                        commit('SET_USER_NAME', response.result.userInfo.account)
                        commit('SET_USER_ID', response.result.userInfo.userId)
                        commit('SET_COMPANY_NAME', response.result.userInfo.companyName)
                        commit('SET_ROLES', response.result.roles)
                        Vue.ls.set(ACCESS_TOKEN, response.result.token, expire)
                        Vue.ls.set(NAME, response.result.userInfo.realName, expire)
                        Vue.ls.set(USER_NAME, response.result.userInfo.account, expire)
                        Vue.ls.set(USER_ID, response.result.userInfo.userId, expire)
                        Vue.ls.set(USER_COMPANY_NAME, response.result.userInfo.companyName, expire)
                        Vue.ls.set(USER_ROLES, response.result.roles, expire)
                    }
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        //退出登录
        Logout({commit, state}) {
            return new Promise((resolve) => {
                commit('SET_TOKEN', '')
                commit('SET_NAME', '')
                commit('SET_USER_ID', '')
                commit('SET_COMPANY_NAME', '')
                commit('SET_ROLES', [])
                commit('SET_AUDIT_STATUS', '')
                commit('SET_ACTIVE', 0)
                commit('SET_APPLY_INFO', {})
                Vue.ls.remove(ACCESS_TOKEN)
                Vue.ls.remove(USER_NAME)
                Vue.ls.remove(USER_ID)
                Vue.ls.remove(USER_COMPANY_NAME)
                Vue.ls.remove(USER_ROLES)
                Vue.ls.remove(AUDIT_STATUS)
                Vue.ls.remove(APPLY_INFO)
                resolve()
            }).catch(err => {
            })
        }
    }
}

export default user
